import {Injectable} from '@angular/core';
import {ParentService} from "./ParentService";
import {StudentEntity} from "../model/StudentEntity";
import {BasicDto} from "../dto/BasicDto";
import {CoursePriceDto} from "../dto/CoursePriceDto";
import {catchError} from "rxjs/operators";
import {Auth} from "../model/Auth";

@Injectable()
export class LoginService extends ParentService{

  public loginManager(username: string, password: string) {
    const loginData = { username, password };

    return this.http.post<Auth>(this.shared.MAGNAMENT_URL+'/loginManager', loginData, this.shared.headers()).pipe(catchError(this.shared.handleErrorLogin));
  }

  public loginTutor(username: string, password: string) {
    const loginData = { username, password };

    return this.http.post<Auth>(this.shared.MAGNAMENT_URL+'/loginTutor', loginData, this.shared.headers()).pipe(catchError(this.shared.handleErrorLogin));
  }

  public loginProfessor(username: string, password: string) {
    const loginData = { username, password };

    return this.http.post<Auth>(this.shared.MAGNAMENT_URL+'/loginProfessor', loginData, this.shared.headers()).pipe(catchError(this.shared.handleErrorLogin));
  }

}
